import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=ad7c1092&scoped=true&"
import script from "./MainTable.vue?vue&type=script&lang=js&"
export * from "./MainTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7c1092",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad7c1092')) {
      api.createRecord('ad7c1092', component.options)
    } else {
      api.reload('ad7c1092', component.options)
    }
    module.hot.accept("./MainTable.vue?vue&type=template&id=ad7c1092&scoped=true&", function () {
      api.rerender('ad7c1092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/project-detail/RadarPointList/MainTable.vue"
export default component.exports